export var CalibrationResult = /*#__PURE__*/function (CalibrationResult) {
  CalibrationResult[CalibrationResult["SUCCESS"] = 1] = "SUCCESS";
  CalibrationResult[CalibrationResult["UNCERTAIN"] = 2] = "UNCERTAIN";
  CalibrationResult[CalibrationResult["FAILURE"] = 3] = "FAILURE";
  CalibrationResult[CalibrationResult["BAD_THERMOMETER"] = 4] = "BAD_THERMOMETER";
  return CalibrationResult;
}(CalibrationResult || {});